import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar } from '@mui/material';
import { withStyles } from '@mui/styles';
import amber from '@mui/material/colors/amber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import green from '@mui/material/colors/green';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';
import { NOTIFICATION_DISPLAY_TIME } from '../../utils';

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon
};

const styles = theme => ({
    success: {
        backgroundColor: green[600]
    },
    error: {
        backgroundColor: theme.palette.error.main
    },
    info: {
        backgroundColor: theme.palette.primary.main
    },
    warning: {
        backgroundColor: amber[700]
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1)
    },
    message: {
        display: 'flex',
        alignItems: 'center'
    },
    snackbarContentRoot: {
        flexWrap: 'nowrap'
    }
});

const AlertDialog = ({
    classes,
    message,
    onClose,
    open,
    variant,
    anchorOrigin = {
        vertical: 'top',
        horizontal: 'right'
    },
    autoHideDuration = NOTIFICATION_DISPLAY_TIME,
    ...other
}) => {
    const Icon = variantIcon[variant];

    return (
        <Snackbar
            anchorOrigin={anchorOrigin}
            open={open}
            onClose={onClose}
            disableWindowBlurListener
            autoHideDuration={autoHideDuration}
        >
            <SnackbarContent
                classes={{
                    root: classes.snackbarContentRoot
                }}
                className={classes[variant]}
                aria-describedby="client-snackbar"
                message={(
                    <span
                        id="client-snackbar"
                        className={classes.message}
                    >
                        <Icon className={classes.iconVariant} />
                        {message}
                    </span>
                )}
                action={(
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={onClose}
                        size="large"
                    >
                        <CloseIcon />
                    </IconButton>
                )}
                {...other}
            />
        </Snackbar>
    );
};

AlertDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
    anchorOrigin: PropTypes.object,
    autoHideDuration: PropTypes.number,
    message: PropTypes.node,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired
};

export default withStyles(styles)(AlertDialog);
